import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { filter, tap } from 'rxjs/operators';
import { LoadingSpinnerService } from '../../shop/src/app/+shared/services/loading-spinner.service';
import { noop } from 'rxjs';
import { BrowserService } from '../services/browser.service';

export const LoaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoadingSpinnerService);
  const browser = inject(BrowserService);
  loader.show()
  return next(req).pipe(
    tap({
      next: (event) => {
        if (req.url.includes('user-categories/main-categories') || req.url.includes('/delivery/')) {
          loader.isLoading$.pipe(
            filter(res => res),
            tap(res => {
              loader.hide()
            }
            )
          ).subscribe(noop)
        }

        if (browser.getLocation()?.pathname.includes('auth')) {
          loader.hide()
        }

      }
    })
  );
};